export const EMPTY_OBJECT = Object.freeze({})
export const NOOP = () => undefined
export const MAX_MOBILE_WIDTH = 960
// Px form of the DS `lg` breakpoint, for viewport arithmetic; DS_LG_MEDIA_QUERY is the exact one.
export const DS_DESKTOP_MIN_WIDTH = 1200
// For APIs that take a media query, not a Panda condition (Embla `breakpoints`, `matchMedia`).
// Must stay in rem: Panda emits `lg` as 75rem, and media-query rem tracks the browser's default
// font size, so a px form parts company with the stylesheet for readers who enlarge it.
// @i18n-ignore
export const DS_LG_MEDIA_QUERY = '(min-width: 75rem)'
export const MAX_DESKTOP_WIDTH = 1600
// @i18n-ignore
export const QUINCE = 'Quince'
export const EN_US = 'en_US'
// @i18n-ignore
export const CONTENT_QUERY_PARAM = 'content-version'
// @i18n-ignore
export const NO_COLOR_OPTION_NAME = 'No Color'
